export const wrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
};

export const titleStyles = {
  fontSize: '12px',
};

export const valueStyles = {
  fontSize: '14px',
  fontWeight: '500',
};
